export class UserData {

    public static readonly SALES_REP_ROLE = "salesRep";
    public static readonly SALES_MANAGER_ROLE = "salesManager";
    public static readonly ADMIN_ROLE = "admin";

    email: string;
    role: string;

    static isSalesRep(user: UserData): boolean {
        return user && user.role === UserData.SALES_REP_ROLE;
    }

    static isSalesManager(user: UserData): boolean {
        return user && user.role === UserData.SALES_MANAGER_ROLE;
    }

    static isAdmin(user: UserData): boolean {
        return user && user.role === UserData.ADMIN_ROLE;
    }
}
